// 将嵌套的数据字典数组扁平化成一层，多个字典的 value 可能重复，但单个字典下不存在重复的 value，所以可以转换后查找
export function flatList(list = [], result = []) {
    list.forEach(item => {
        result.push(item)
        if (Array.isArray(item.children) && item.children.length > 0) {
            flatList(item.children, result)
        }
    })
}